import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { history } from "./history";
import { Alert } from "./components/alert/Alert";
import Sidebar from "./components/sidebar/Sidebar";
import LoginPage from "./features/user/LoginPage";
import DashboardPage from "./features/dashboard/DashboardPage";
import ApprovalListPage from "./features/approval/ApprovalListPage";

// MASTER
import MasterPage from "./features/master/index";
import MainAccountPage from "./features/master/main-account/MainAccountPage";
import SubAccountPage from "./features/master/sub-account/SubAccountPage";
import SubGroupAccountPage from "./features/master/sub-group-account/SubGroupAccountPage";
import DetailAccountPage from "./features/master/activity/detail-account/DetailAccountPage";
import GudangPage from "./features/master/gudang/GudangPage";
import KemasanPage from "./features/master/kemasan/KemasanPage";
import OumPage from "./features/master/oum/OumPage";
import GudangIndexPage from "./features/gudang/";

import LimbahPage from "./features/master/limbah/LimbahPage";
import KelompokKegiatanPage from "./features/master/kelompok-kegiatan/KelompokKegiatanPage";
import SubKegiatanPage from "./features/master/sub-kegiatan/SubKegiatanPage";
import KegiatanPage from "./features/master/kegiatan/KegiatanPage";
import KendaraanPage from "./features/master/kendaraan/KendaraanPage";
import GeneralServiceUnitPage from "./features/master/general-service-unit/generalServiceUnitPage";
import RentalUnitPage from "./features/master/rental-unit/rentalUnitPage";

import KlienPage from "./features/master/klien/KlienPage";
import MpayrollPage from "./features/master/payroll/MPayrollPage";
import MpayrollPageHO from "./features/master/payroll-ho/MPayrollPage";
import CostumerPage from "./features/master/costumer/CostumerPage";

import BisnisUnitPage from "./features/master/bisnis-unit/BisnisUnitPage";
import ProvinsiPage from "./features/master/provinsi/ProvinsiPage";
import LokasiTugasPage from "./features/master/lokasi-tugas/LokasiTugasPage";
import SatuanPage from "./features/master/satuan/SatuanPage";
import JenisPetugasPage from "./features/master/jenis-petugas/JenispetugasPage";
import ActivityequipmentPage from "./features/master/activity-equpment/ActivityequpmentPage";
import KotaPage from "./features/master/kota/KotaPage";
import TipeKaryawanPage from "./features/master/tipe-karyawan/TipeKaryawanPage";
import GolonganPage from "./features/master/golongan/GolonganPage";
import BagianPage from "./features/master/bagian/BagianPage";
import BankPage from "./features/master/bank/BankPage";
import JabatanPage from "./features/master/jabatan/JabatanPage";
import JettyPage from "./features/master/jetty/JettyPage";
import RoomPage from "./features/master/room/roomPage";

import ChangePassPage from "./features/user/ChangePassPage";

// SETUP
import SetupPage from "./features/setup";
import SetupCutiPage from "./features/setup/cuti/CutiPage";
import SetupLemburPage from "./features/setup/lembur/LemburPage";
import JamKerjaPage from "./features/setup/jam-kerja/JamKerjaPage";
import PlafonPerobatanPage from "./features/setup/plafon-perobatan/PlafonPerobatanPage";
import UserPage from "./features/setup/user/userPage";
import OtoritasPage from "./features/setup/user/OtoritasPage";

// HRD
import HumanResourcePage from "./features/hrd";
import LayananMandiri from "./features/hrd/LayananMandiri";
import OperationalPage from "./features/operasional";
import AkomodasiPage from "./features/operasional/akomodasi/AkomodasiPage";
import EquipmentPage from "./features/equipment";
import HsePage from "./features/hse";
import GeneralAffairPage from "./features/general-affair";
import ResepPage from "./features/general-affair/resep/ResepPage";
import PrasmananPage from "./features/general-affair/prasmanan/PrasmananPage";
import BarcodeKamarPage from "./features/general-affair/prasmanan/BarcodeKamarPage";
import MakanKamarPage from "./features/makan/MakanKamarPage";
import MonitoringPage from "./features/hrd/monitoring/MonitoringPage";
import KaryawanPage from "./features/hrd/karyawan/KaryawanPage";
import KaryawanFile from "./features/hrd/karyawan/KaryawanFile";

import MonCSR from "./features/hrd/csr";
import InsertCSR from "./features/hrd/csr/tambah";

import ApprovalPage from "./features/setup/approval/ApprovalPage";
import CutiPage from "./features/hrd/transaksi/cuti/CutiPage";
import EntryCutiPage from "./features/hrd/transaksi/cuti/EntryCutiPage";
import InputSaldoCutiPage from "./features/hrd/transaksi/saldo-cuti/InputSaldoCutiPage";
import CutiMandiri from "./features/hrd/transaksi/cuti/CutiMandiri";
import IzinPage from "./features/hrd/transaksi/izin/IzinPage";
import PerbaikanPage from "./features/hrd/transaksi/perbaikan-absen/PerbaikanPage";
import AbsensiPage from "./features/hrd/transaksi/absensi/AbsensiPage";
import JadwalKerjaPage from "./features/hrd/transaksi/jadwal-kerja/JadwalKerjaPage";
import FaceEnrollmentPage from "./features/hrd/transaksi/face-enrollment/FaceEnrollmentPage";
import KioskDevicePage from "./features/hrd/transaksi/kiosk-device/KioskDevicePage";
import KioskAbsensiPage from "./features/kiosk/absensi-wajah/KioskAbsensiPage";
import IzinMandiri from "./features/hrd/transaksi/izin/IzinMandiri";
import PelatihanPage from "./features/hrd/transaksi/pelatihan/PelatihanPage";
import TiketPage from "./features/hrd/transaksi/tiket/TiketPage";
import LemburPage from "./features/hrd/transaksi/lembur/LemburPage";
import ClaimPengobatanPage from "./features/hrd/transaksi/claim-pengobatan/ClaimPengobatanPage";
import PhkPage from "./features/hrd/transaksi/phk/PhkPage";
import ResignPage from "./features/hrd/transaksi/resign/ResignPage";
import PromosiPage from "./features/hrd/transaksi/promosi/PromosiPage";
import KontrakKerjaPage from "./features/hrd/transaksi/kontrak-kerja/KontrakKerjaPage";
import PerjalananDinasPage from "./features/hrd/transaksi/perjalanan-dinas/PerjalananDinasPage";
import TarifUangSakuPage from "./features/hrd/transaksi/perjalanan-dinas/TarifUangSakuPage";
import LpdTrackerPage from "./features/hrd/transaksi/perjalanan-dinas/LpdTrackerPage";
import EditJobRequestPage from "./features/hrd/transaksi/job-request/EditJobRequestPage";
import JobRequestOperasionalPage from "./features/operasional/job-request/JobRequestOperasionalPage";
import JobRequestDetailOperasionalPage from "./features/operasional/job-request/JobRequestDetailOperasional";
import JobRequestFormPage from "./features/operasional/job-request/JobRequestFormPage";
import JobRequestMonitoringV2 from "./features/operasional/job-request/JobRequestMonitoringV2";
import JobRequestDetailV2 from "./features/operasional/job-request/JobRequestDetailV2";
import OperasionalShippingManifestDetail from "./features/operasional/shipping-manifest/OperasionalShippingManifestDetail";
import OperasionalShippingManifestPage from "./features/operasional/shipping-manifest/OperasionalShippingManifestPage";
import OperasionalPermitDetail from "./features/operasional/permit/OperasionalPermitDetail";
import OperasionalPermitPage from "./features/operasional/permit/OperasionalPermitPage";
import CetakJR from "./features/operasional/output/CetakJR";
import CetakJrV2 from "./features/operasional/job-request/CetakJrV2";
import JrVersionComparePage from "./features/operasional/job-request/JrVersionComparePage";
import OperationalOutputDetail from "./features/operasional/output/OperationalOutputDetail";
import OperationalOutputDetailApproval from "./features/operasional/output/OperationalOutputDetailApproval";

import OperationalOutputPage from "./features/operasional/output/OperationalOutputPage";
import ActivityDetailV2 from "./features/operasional/output/ActivityDetailV2";
import PermintaanUnitDetail from "./features/operasional/permintaanUnit/PermintaanUnitDetail";
import PermintaanUnitPage from "./features/operasional/permintaanUnit/PermintaanUnitPage";
import QuatationMonitoringPage from "./features/operasional/quatation/QuatationMonitoringPage";
import QuatationAdditionalMonitoringPage from "./features/operasional/quatation/QuatationAdditionalMonitoringPage";

import QuatationOperasionalPage from "./features/operasional/quatation/QuatationOperasionalPage";
import QuatationDetailOperasionalPage from "./features/operasional/quatation/QuatationDetailOperasionalPage";
import QuotationFormPage from "./features/operasional/quatation/QuotationFormPage";
import InvoiceGeneratePage from "./features/operasional/quatation/InvoiceGeneratePage";
import InvoiceListV2 from "./features/operasional/quatation/InvoiceListV2";
import InvoiceDetailV2 from "./features/operasional/quatation/InvoiceDetailV2";
import Header from "./components/header/Header";
import LogisticPage from "./features/logistic";
import FinancePage from "./features/finance";
import AccountingPage from "./features/accounting";
import FixedAssetPage from "./features/fixed-assets";
import WorkshopPage from "./features/workshop";
import WastePage from "./features/master/waste-management/wastePage";
import PortServicePage from "./features/master/port-service/portServicePage";
import GeneralServiceItemPage from "./features/master/general-service-item/generalServiceItemPage";
import StrukturOrganisasiPage from "./features/master/struktur-organisasi/StrukturOrganisasiPage";
import CargoPage from "./features/master/cargo-carrying-unit/cargoPage";
import MealsPage from "./features/master/meals/mealsPage";
import LabourPage from "./features/master/labour/labourPage";
import TypeOfClothingPage from "./features/master/type-of-clothing/typeOfClothingPage";
import FuelPage from "./features/master/fuel/fuelPage";
import DistentionPage from "./features/master/distention/distentionPage";

import AreaRentalPage from "./features/master/area-rental/areaRentalPage";
import RentalPage from "./features/master/rental/rentalPage";
import QuatationAdditionalOperasionalPage from "./features/operasional/quatation/QuatationAdditionalOperasionalPage";
import OperationalSummaryPage from "./features/operasional/summary/OperationalSummaryPage";
import JobRequestOperasionalPageFinance from "./features/operasional/job-request/JobRequestOperasionalPageFinance";
import ReportMJS from "./features/operasional/job-request/ReportMJS";
import JobRequestOperasionalPageReports from "./features/operasional/job-request/JobRequestOperasionalPageReports";
import MJSPage from "./features/operasional/quatation/MJSPage";
import MasterCutiPage from "./features/master/cuti/cutiPage";
import TanggalMerahPage from "./features/master/tanggalMerah/tanggalMerahPage";
import PenyakitPage from "./features/master/penyakit/penyakitPage";
import SakitPage from "./features/hrd/transaksi/sakit/sakitPage";
import SakitReport from "./features/hrd/transaksi/sakit/sakitReport";
import IzinReport from "./features/hrd/transaksi/izin/IzinReport";
import CutiReport from "./features/hrd/transaksi/cuti/cutiReport";
import PelatihanReport from "./features/hrd/transaksi/pelatihan/PelatihanReport";
import TiketReport from "./features/hrd/transaksi/tiket/TiketReport";
import LemburReport from "./features/hrd/transaksi/lembur/lemburReport";
import ClaimReport from "./features/hrd/transaksi/claim-pengobatan/ClaimReport";
import PhkReport from "./features/hrd/transaksi/phk/PhkReport";
import ResignReport from "./features/hrd/transaksi/resign/ResignReport";
import KaryawanReport from "./features/hrd/karyawan/KaryawanReport";
import MasterKelompokPage from "./features/master/kelompok/kelompok";
import { ToastContainer } from "react-toastify";
import MasterBarangPage from "./features/master/barang/barang";
import MasterUserPCPage from "./features/master/userpc/userpc";
import MasterFrancoPage from "./features/master/franco/franco";
import ProcurmentPage from "./features/procurment";
import PurchaseRequisitionPage from "./features/procurment/purchase-requisition/purchase-requisition";
import InsertPurchaseRequisitionPage from "./features/procurment/purchase-requisition/insert-purchase-requisition";
import MonPurchaseRequisitionPage from "./features/procurment/purchase-requisition/monitoring-purchase-requisition";
import InsertPriceComparisonPage from "./features/procurment/price-comparison/insert-price-comparasion";
import PriceComparisonPage from "./features/procurment/price-comparison/price-comparison";
import ApprovalPurchaseRequisitionPage from "./features/procurment/purchase-requisition/approval-purchase-requisition";
import ApprovalPurchaseOrderPage from "./features/procurment/purchase-order/approval-purchase-order";
import AllocationPurchaseRequisitionPage from "./features/procurment/purchase-requisition/allocation-purchase-requisition";
import InsertAllocationPurchaseRequisitionPage from "./features/procurment/purchase-requisition/allocation-form-purchase-requisition";
import KirimPurchaseRequisitionPage from "./features/procurment/purchase-requisition/kirim-purchase-requisition";
import ApprovalListPagePC from "./features/approval/ApprovalListPC";
import ApprovalPurchaseComparationPage from "./features/procurment/price-comparison/approval-purchase-comparasion";
import PurchaseOrderPage from "./features/procurment/purchase-order/purchase-order";
import InsertPurchaseOrderPage from "./features/procurment/purchase-order/insert-purchase-order";
import MasterSupplierPage from "./features/master/supplier/supplier";
import MasterDesaPage from "./features/master/desa/desa";

import MasterActivityPage from "./features/master/activitys/activity";
import PenerimaanBarangPage from "./features/gudang/penerimaan-barang/penerimaan-barang";
import InsertPenerimaanBarangPage from "./features/gudang/penerimaan-barang/insert-penerimaan-barang";
import PengeluaranBarang from "./features/gudang/pengeluaran-barang/pengeluaran-barang";
import InsertPengeluaranBarangPage from "./features/gudang/pengeluaran-barang/insert-pengeluaran-barang";
import ReturnBarangPage from "./features/gudang/returrn-barang/return-barang";
import InsertReturnBarangPage from "./features/gudang/returrn-barang/return-pengeluaran-barang";
import PenerimaanBarangUserPage from "./features/gudang/penerimaan-barang-user/penerimaan-barang";
import InsertPenerimaanBarangUserPage from "./features/gudang/penerimaan-barang-user/penerimaan-barang-user";
import ApprovalPenerimaanBarangUserPage from "./features/gudang/penerimaan-barang-user/approval-penerimaan-barang";
import ApprovalPenerimaanBarangPage from "./features/gudang/penerimaan-barang/approval-penerimaan-barang";
import ApprovalPengeluaranBarangPage from "./features/gudang/pengeluaran-barang/approval-pengeluaran-barang";
import ReturnPenerimaanBarangPage from "./features/gudang/returrn-barang/approval-return-barang";
import TransaksiKendaraanPage from "./features/kendaraan/transaksi-kendaraan/transaksi-kendaraan";
import InsertKendaraanPage from "./features/kendaraan/transaksi-kendaraan/insert-transaksi-kendaraan";
import UpdateKendaraanPage from "./features/kendaraan/transaksi-kendaraan/update-transaksi-kendaraan";

import AccountPayable from "./features/finance/AccountPayable/AccountPayable";
import PembayaranAPPage from "./features/finance/pembayaran-ap";
import NegaraPage from "./features/master/negara/NegaraPage";
import KasBankPage from "./features/finance/kas-bank";
import InsertKasBankPage from "./features/finance/kas-bank/inser-kasbank";
import JurnalPage from "./features/finance/jurnal";
import ReportJurnalPage from "./features/finance/jurnal/report";

import InsertJurnalPage from "./features/finance/jurnal/inser-jurnal";
import StockPage from "./features/gudang/stok";
import AdjustStockPage from "./features/gudang/stok/adjuststock";
import InsertAccountPayable from "./features/finance/AccountPayable/Insert-AccountPayable";
import MonitoringProcurmentPage from "./features/procurment/monitoring";
import BlankoPO from "./features/procurment/Blanko/BlankoPO";
import ReportBukuBesarPage from "./features/finance/BukuBesar/report";
import ReportTrialBalancePage from "./features/finance/Trial-Balance/report";
import MonitoringGudang from "./features/gudang/monitoring";
import BlankoPenerimaan from "./features/gudang/blanko/penerimaan";
import PreviewPurchaseRequisitionPage from "./features/procurment/purchase-requisition/preview-purchase-requisition";
import PreviewPurchaseComparationPage from "./features/procurment/price-comparison/preview-purchase-comparasion";
import ReportBukuKas from "./features/finance/BukuKas";
import ReportBukuBank from "./features/finance/BukuBank";
import ReportNeraca from "./features/finance/Neraca";
import LaporanGudang from "./features/gudang/laporan";
import MonitoringAP from "./features/finance/MonAP";
import Vocherpembayaran from "./features/finance/pembayaran-ap/vocher";
import QuatationLaporan from "./features/operasional/quatation/QuatationLaporan";
import QuotationInvoicePage from "./features/operasional/quatation/Invoice";
import CetakInvoice from "./features/operasional/quatation/CetakInvoice";
import CetakInvoiceV2 from "./features/operasional/quatation/CetakInvoiceV2";
import MasterApprovalv2 from "./features/setup/approval";
import ApprovalKasBankPage from "./features/finance/kas-bank/approval";
import MonitoringNonPO from "./features/finance/kas-bank/monitoring";
import DetailKasBank from "./features/finance/kas-bank/detail";
import BlankoKasBank from "./features/finance/kas-bank/blanko";
import BlankoPembayaranAP from "./features/finance/pembayaran-ap/blanko";
import BlankoJurnal from "./features/finance/jurnal/blanko";
import PattyCashPage from "./features/finance/kas-bank/pettycash";
import InsertPettyCashPage from "./features/finance/kas-bank/insert-pettycash";
import ApprovalJurnalPage from "./features/finance/jurnal/approval";
import ApprovalPattyCashPage from "./features/finance/kas-bank/approval-pattycash";
import ReportLabaRugi from "./features/finance/laba-rugi";
import SaldoAwal from "./features/master/activity/detail-account/SaldoAwal";
import MonitoringJurnal from "./features/accounting/monitoringJurnal";
import MonitoringPattyCashHO from "./features/finance/kas-bank/MonitoringSO";
import MonitoringPattyCashSO from "./features/finance/kas-bank/MonitoringHO";
import Closing from "./features/finance/closing";
import PenerimaanCash from "./features/finance/kas-bank/insert-penerimaan";
import InsertPenerimaanPage from "./features/finance/kas-bank/insert-PenerimaanPage";
import MonitoringPenerimaanSO from "./features/finance/kas-bank/monitoring-penerimaan-so";
import MonitoringPenerimaanHO from "./features/finance/kas-bank/monitoring-penerimaan-ho";
import PenerimaanDana from "./features/finance/kas-bank/penerimaan-dana";
import InsertPenerimaanDana from "./features/finance/kas-bank/insert-penerimaan-dana";
import MonitoringPenerimaanDana from "./features/finance/kas-bank/MonitoringPenerimaanDana";
import MonitoringInvoiceQuatation from "./features/finance/kas-bank/MonitoringInvoiceQuatation";
import ApprovalCashBank from "./features/finance/kas-bank/approval-aksi";
import EditLockedKasBank from "./features/finance/kas-bank/edit-kasbank-lock";
import MonitoringPurchaseOrder from "./features/procurment/monitoring/MonitoringPurchaseOrder";
import MonitoringPurchaseRequisiton from "./features/procurment/monitoring/MonitoringPurchaseRequisiton";
import MonitoringPriceComparison from "./features/procurment/monitoring/MonitoringPriceComparison";
import BlankoPR from "./features/procurment/Blanko/BlankoPR";
import DeletePurchaseRequisitionPage from "./features/procurment/purchase-requisition/delete-purchase-requisition";
import EditAttachmentPurchaseRequisitionPage from "./features/procurment/purchase-requisition/edit-attachment-purchase-requisition";
import EditAttachmentPriceComparisonPage from "./features/procurment/price-comparison/edit-attachment-price-comparison";
import DeletePurchaseComparationPage from "./features/procurment/price-comparison/delete-price-comparison";
import ReadPenerimaanBarangPage from "./features/gudang/penerimaan-barang/read-only-penerimaanbarang";
import InsertPenerimaanBarangPageV1 from "./features/gudang/penerimaan-barang/insert-penerimaan-barangv1";
import ApprovalAccountPayable from "./features/finance/AccountPayable/Approval-AccountPayable";
import MonitoringPengeluaran from "./features/gudang/MonitoringPengeluaran";
import MonitoringLapPengeluaran from "./features/gudang/LaporanPengeluaran";
import FastMovingPage from "./features/gudang/FastMoving";
import POTransitPage from "./features/gudang/POTransit";
import ReadPengeluaranBarangPage from "./features/gudang/pengeluaran-barang/read-pengeluaran-barang";
import ReportPurchaseRequisiton from "./features/procurment/monitoring/ReportPurchaseRequisiton";
import ReportPurchaseOrder from "./features/procurment/monitoring/ReportPurchaseOrder";
import ApprovalKendaraanPage from "./features/kendaraan/transaksi-kendaraan/Approval-kendaraan";
import MonitoringKendaraan from "./features/kendaraan/Monitoring-kendaraan";
import PreviewKendaraanPage from "./features/kendaraan/transaksi-kendaraan/Preview-kendaraan";
import ReportKendaraan from "./features/kendaraan/Report-kendaraan";
import IndexPayrollDetail from "./features/payroll/so/detail";
import SlipGaji from "./features/payroll/rekap-so/slipgaji";
import IndexPayrollSO from "./features/payroll/so/index";
import IndexPayroll from "./features/payroll/index";
import RekapPayrollSO from "./features/payroll/rekap-so/index";
import PayrollPageReport from "./features/payroll/report/index";
import IndexMemo from "./features/memo/index";
import ReportMemoPdf from "./features/memo/memo/pdf";
import MemoReportPage from "./features/memo/memo/report";
import MemoReportAllPage from "./features/memo/memo/report-all";
import InternalMemo from "./features/memo/memo/index";
import InternalMemoAll from "./features/memo/memo/indexall";
import InternalMemoDetail from "./features/memo/memo/detail";

const queryClient = new QueryClient();

const AuthCheck = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user?.Tipe === "Karyawan") {
    return (
      <>
        <Sidebar />
        <Outlet />
      </>
    );
  } else if (user?.Tipe === "Customer") {
    return (
      <>
        <Header />
        <Outlet />
      </>
    );
  } else {
    return <Navigate to="/login" />;
  }
};
const ReactQueryDevtoolsProduction = React.lazy(() =>
  import("@tanstack/react-query-devtools/build/lib/index.prod.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

const CheckLogin = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  return user ? <Navigate to="/" /> : <Outlet />;
};

function App() {
  let user = JSON.parse(localStorage.getItem("user"));
  return (
    <QueryClientProvider client={queryClient}>
      <Router history={history}>
        <Alert />
        <Routes>
          <Route path="/login" element={<CheckLogin />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>
          {/* Kiosk absensi wajah - SATU-SATUNYA halaman di app ini yang render
              tanpa Sidebar/Header, karena tablet kiosk tak pernah login sbg
              karyawan. Auth-nya device-token (X-Device-Token), bukan JWT -
              lihat backend/middleware/kioskDevice.middleware.go. Diletakkan
              di luar <AuthCheck/> dgn sengaja. */}
          <Route path="/kiosk/absensi-wajah" element={<KioskAbsensiPage />} />
          {/* Scan barcode kamar (penghuni): publik, dilindungi token acak per kamar. */}
          <Route path="/makan/:token" element={<MakanKamarPage />} />
          <>
            {user?.Tipe === "Customer" ? (
              <Route path="/" element={<AuthCheck />}>
                <Route exact path="/" element={<JobRequestMonitoringV2 />} />
                <Route
                  path="/create-job-Request"
                  element={<JobRequestFormPage />}
                />
                <Route
                  path="/operasional-job-request-detail-v2"
                  element={<JobRequestDetailV2 />}
                />
                <Route path="/jr-version-compare" element={<JrVersionComparePage />} />
                {/* Print JR dari Daftar Job Request klien (Pending Client/Approved).
                    Dulu hanya terdaftar di rute karyawan -> klien dapat layar putih. */}
                <Route path="/cetak-jr-v2" element={<CetakJrV2 />} />
                <Route
                  path="/detail-job-request"
                  element={<EditJobRequestPage />}
                />
                <Route
                  path="/operasional-activity-approval"
                  element={<OperationalOutputDetailApproval />}
                />
              </Route>
            ) : (
              <Route path="/" element={<AuthCheck />}>
                <Route exact path="/" element={<DashboardPage />} />
                <Route
                  exact
                  path="/change-password"
                  element={<ChangePassPage />}
                />
                <Route path="/approval-list" element={<ApprovalListPage />} />
                <Route
                  path="/setup-approval-pc"
                  element={<ApprovalListPagePC />}
                />

                <Route path="/approval-list-old" element={<ApprovalPage />} />

                {/* MASTER */}
                <Route path="/master" element={<MasterPage />} />
                <Route
                  path="/master-main-account"
                  element={<MainAccountPage />}
                />
                <Route
                  path="/master-sub-account"
                  element={<SubAccountPage />}
                />
                <Route
                  path="/master-sub-group-account"
                  element={<SubGroupAccountPage />}
                />
                <Route
                  path="/master-detail-account"
                  element={<DetailAccountPage />}
                />
                <Route path="/saldo-awal" element={<SaldoAwal />} />
                <Route path="/master-Location-Used" element={<GudangPage />} />
                <Route
                  path="/master/kelompok-kegiatan"
                  element={<KelompokKegiatanPage />}
                />
                <Route
                  path="/master-sub-kegiatan"
                  element={<SubKegiatanPage />}
                />
                <Route path="/master-kegiatan" element={<KegiatanPage />} />
                <Route path="/master-unit" element={<KendaraanPage />} />
                <Route
                  path="/master-rental-unit"
                  element={<RentalUnitPage />}
                />
                <Route
                  path="/master-general-service-unit"
                  element={<GeneralServiceUnitPage />}
                />
                <Route path="/master-klien" element={<CostumerPage />} />
                <Route path="/master-customer" element={<KlienPage />} />
                <Route path="/master-payroll" element={<MpayrollPage />} />
                <Route path="/master-payroll-ho" element={<MpayrollPageHO />} />
                <Route
                  path="/master-bisnis-unit"
                  element={<BisnisUnitPage />}
                />
                <Route path="/master-provinsi" element={<ProvinsiPage />} />
                <Route
                  path="/master-lokasi-tugas"
                  element={<LokasiTugasPage />}
                />
                <Route path="/master-satuan" element={<SatuanPage />} />
                <Route
                  path="/master-jenis-petugas"
                  element={<JenisPetugasPage />}
                />
                <Route
                  path="/master-activity-equipment"
                  element={<ActivityequipmentPage />}
                />
                <Route
                  path="/master-type-packaging"
                  element={<KemasanPage />}
                />
                <Route path="/master-Uom" element={<OumPage />} />
                <Route
                  path="/master-waste-management"
                  element={<WastePage />}
                />
                <Route
                  path="/master-port-service"
                  element={<PortServicePage />}
                />
                <Route
                  path="/master-general-service-item"
                  element={<GeneralServiceItemPage />}
                />
                <Route
                  path="/master-struktur-organisasi"
                  element={<StrukturOrganisasiPage />}
                />
                <Route
                  path="/master-Cargo-Carrying-Unit"
                  element={<CargoPage />}
                />
                <Route path="/master-haz-waste" element={<LimbahPage />} />
                <Route
                  path="/master-kotamadya-atau-kabupaten"
                  element={<KotaPage />}
                />
                <Route
                  path="/master-tipe-karyawan"
                  element={<TipeKaryawanPage />}
                />
                <Route path="/master-golongan" element={<GolonganPage />} />
                <Route path="/master-bagian" element={<BagianPage />} />
                <Route path="/master-bank" element={<BankPage />} />
                <Route path="/master-negara" element={<NegaraPage />} />

                <Route path="/master-jabatan" element={<JabatanPage />} />
                <Route path="/master-jetty" element={<JettyPage />} />
                <Route path="/master-room" element={<RoomPage />} />
                <Route path="/master-manpower" element={<LabourPage />} />
                <Route path="/master-penyakit" element={<PenyakitPage />} />

                <Route path="/master-cuti" element={<MasterCutiPage />} />
                <Route
                  path="/master-tanggal-merah"
                  element={<TanggalMerahPage />}
                />

                <Route path="/master-meals" element={<MealsPage />} />
                <Route
                  path="/master-type-of-clothing"
                  element={<TypeOfClothingPage />}
                />
                <Route
                  path="/master-destination"
                  element={<DistentionPage />}
                />

                <Route path="/master-fuel" element={<FuelPage />} />

                <Route
                  path="/master-area-rental"
                  element={<AreaRentalPage />}
                />
                <Route path="/master-rental" element={<RentalPage />} />
                <Route
                  path="/master/kelompok"
                  element={<MasterKelompokPage />}
                />
                <Route path="/master/barang" element={<MasterBarangPage />} />
                <Route path="/master/user-pc" element={<MasterUserPCPage />} />
                <Route
                  path="/master/supplier"
                  element={<MasterSupplierPage />}
                />
                <Route path="/master/desa" element={<MasterDesaPage />} />

                <Route path="/master/franco" element={<MasterFrancoPage />} />

                <Route path="/setup/approval" element={<MasterApprovalv2 />} />

                <Route
                  path="/master/activity"
                  element={<MasterActivityPage />}
                />
                <Route path="/master/kendaraan" element={<KendaraanPage />} />

                <Route path="/setup" element={<SetupPage />} />
                <Route path="/setup-cuti" element={<SetupCutiPage />} />
                <Route path="/cuti-mandiri" element={<CutiMandiri />} />
                <Route path="/setup-lembur" element={<SetupLemburPage />} />
                <Route path="/setup-jam-kerja" element={<JamKerjaPage />} />
                <Route
                  path="/setup-plafon-perobatan"
                  element={<PlafonPerobatanPage />}
                />
                <Route path="/setup-approval" element={<ApprovalPage />} />
                <Route path="/setup-fixed-asset" element={<DashboardPage />} />
                <Route path="/setup-user" element={<UserPage />} />
                <Route path="/setup-otoritas/:id" element={<OtoritasPage />} />
                {/* Operational */}
                <Route path="/operasional" element={<OperationalPage />} />
                <Route
                  path="/operasional-akomodasi"
                  element={<AkomodasiPage />}
                />
                <Route
                  path="/operasional-job-request"
                  element={<JobRequestOperasionalPage />}
                />
                <Route
                  path="/operasional-monitoring-finance"
                  element={<JobRequestOperasionalPageFinance />}
                />
                <Route
                  path="/operasional-fianance-reports"
                  element={<JobRequestOperasionalPageReports />}
                />
                <Route
                  path="/operasional-Summary"
                  element={<OperationalSummaryPage />}
                />
                <Route
                  path="/operasional-job-request-detail"
                  element={<JobRequestDetailOperasionalPage />}
                />
                <Route
                  path="/operasional-job-request-form"
                  element={<JobRequestFormPage />}
                />
                <Route
                  path="/operasional-job-request-edit"
                  element={<JobRequestFormPage />}
                />
                <Route
                  path="/operasional-job-request-list"
                  element={<JobRequestMonitoringV2 />}
                />
                <Route path="/cetak-jr-v2" element={<CetakJrV2 />} />
                <Route
                  path="/operasional-job-request-detail-v2"
                  element={<JobRequestDetailV2 />}
                />
                <Route path="/jr-version-compare" element={<JrVersionComparePage />} />
                <Route
                  path="/invoice-list-v2"
                  element={<InvoiceListV2 />}
                />
                <Route
                  path="/invoice-generate-v2"
                  element={<InvoiceGeneratePage />}
                />
                <Route
                  path="/invoice-detail-v2"
                  element={<InvoiceDetailV2 />}
                />
                <Route
                  path="/invoice-cetak-v2"
                  element={<CetakInvoiceV2 />}
                />
                <Route
                  path="/operasional-shipping-manifest"
                  element={<OperasionalShippingManifestPage />}
                />
                <Route
                  path="/operasional-shipping-manifest-detail"
                  element={<OperasionalShippingManifestDetail />}
                />
                <Route
                  path="/operasional-permit"
                  element={<OperasionalPermitPage />}
                />
                <Route
                  path="/operasional-permit-detail"
                  element={<OperasionalPermitDetail />}
                />
                <Route path="/report-mjs" element={<ReportMJS />} />

                <Route
                  path="/equipment/permintaan-unit"
                  element={<PermintaanUnitPage />}
                />
                <Route
                  path="/operasional-permintaan-unit-detail"
                  element={<PermintaanUnitDetail />}
                />
                <Route path="/cetak-jr" element={<CetakJR />} />
                <Route
                  path="/operasional-activity-detail"
                  element={<OperationalOutputDetail />}
                />
                <Route
                  path="/operasional-activity-approval"
                  element={<OperationalOutputDetailApproval />}
                />
                <Route
                  path="/operasional-activity"
                  element={<OperationalOutputPage />}
                />
                <Route
                  path="/operasional-activity-detail-v2"
                  element={<ActivityDetailV2 />}
                />
                <Route
                  path="/quotation-or-contract-list"
                  element={<QuatationMonitoringPage />}
                />
                <Route
                  path="/monitoring-additional-quotation-or-contract"
                  element={<QuatationAdditionalMonitoringPage />}
                />
                <Route
                  path="/add-quotation-or-contract"
                  element={<QuotationFormPage />}
                />
                <Route
                  path="/edit-quotation-or-contract"
                  element={<QuotationFormPage />}
                />
                <Route
                  path="/add-additional-quotation-or-contract"
                  element={<QuatationAdditionalOperasionalPage />}
                />
                <Route
                  path="/quotation-detail-or-contract"
                  element={<QuatationDetailOperasionalPage />}
                />
                <Route path="/mjs" element={<MJSPage />} />
                <Route
                  path="/finance/invoice/Quotation"
                  element={<QuotationInvoicePage />}
                />
                {/* TEMP EMPTY */}
                <Route path="/master-barang" element={<DashboardPage />} />
                <Route
                  path="/master-Kelompok-barang"
                  element={<DashboardPage />}
                />
                <Route path="/master-top" element={<DashboardPage />} />
                <Route
                  path="/master-main-account"
                  element={<DashboardPage />}
                />
                <Route path="/master-sub-account" element={<DashboardPage />} />

                <Route
                  path="/master-group-account"
                  element={<DashboardPage />}
                />
                <Route
                  path="/master-sub-group-account"
                  element={<DashboardPage />}
                />
                <Route path="/master-group-asset" element={<DashboardPage />} />
                <Route
                  path="/master-sub-group-asset"
                  element={<DashboardPage />}
                />
                <Route
                  path="/master-group-kendaraan"
                  element={<DashboardPage />}
                />
                <Route path="/master-kegiatan" element={<DashboardPage />} />
                <Route path="/master-coa" element={<DashboardPage />} />
                <Route
                  path="/permintaan-barang-baru"
                  element={<DashboardPage />}
                />
                <Route
                  path="/permintaan-barang-dari-gudang"
                  element={<DashboardPage />}
                />
                <Route
                  path="/gudang/penerimaan"
                  element={<MonitoringGudang />}
                />
                <Route
                  path="/gudang/pengeluaran"
                  element={<MonitoringPengeluaran />}
                />
                <Route
                  path="/gudang/lap-pengeluaran"
                  element={<MonitoringLapPengeluaran />}
                />
                <Route path="/gudang/fast-moving" element={<FastMovingPage />} />
                <Route path="/gudang/po-transit" element={<POTransitPage />} />

                <Route
                  path="/gudang/lap-penerimaan"
                  element={<LaporanGudang />}
                />

                <Route path="/pembelian-barang" element={<DashboardPage />} />
                <Route path="/penerimaan-barang" element={<DashboardPage />} />
                <Route path="/pengeluaran-barang" element={<DashboardPage />} />
                <Route path="/perjalanan" element={<DashboardPage />} />
                <Route path="/penyusutan" element={<DashboardPage />} />
                <Route path="/workshop" element={<DashboardPage />} />
                <Route path="/pembayaran-hutang" element={<DashboardPage />} />
                <Route path="/penagihan-piutang" element={<DashboardPage />} />
                <Route
                  path="/penerimaan-dan-pengeluaran"
                  element={<DashboardPage />}
                />
                <Route path="/pengeluaran-kas" element={<DashboardPage />} />
                <Route path="/buku-besar" element={<DashboardPage />} />
                <Route path="/jurnal-umum" element={<DashboardPage />} />
                {/*Mandiri*/}
                <Route path="/layanan-mandiri" element={<LayananMandiri />} />
                <Route path="/izin-mandiri" element={<IzinMandiri />} />

                {/*Procurment*/}
                <Route path="/procurment" element={<ProcurmentPage />} />
                <Route
                  path="/procurment/transaction/Material-and-Services-Request"
                  element={<MonPurchaseRequisitionPage />}
                />
                <Route
                  path="/procurment/transaction/Material-and-Services-Request/:id"
                  element={<MonPurchaseRequisitionPage />}
                />

                <Route
                  path="/procurment/transaction/Allocation"
                  element={<AllocationPurchaseRequisitionPage />}
                />
                <Route
                  path="/procurment/transaction/Allocation/:id"
                  element={<AllocationPurchaseRequisitionPage />}
                />

                <Route
                  path="/procurment/approval/purchase-requisition"
                  element={<ApprovalPurchaseRequisitionPage />}
                />

                <Route
                  path="/procurment/preview/purchase-requisition/:id/:transid"
                  element={<PreviewPurchaseRequisitionPage />}
                />
                <Route
                  path="/procurment/delete/purchase-requisition/:id/:transid"
                  element={<DeletePurchaseRequisitionPage />}
                />
                <Route
                  path="/procurment/edit-attachment/purchase-requisition/:bu/:id"
                  element={<EditAttachmentPurchaseRequisitionPage />}
                />
                <Route
                  path="/procurment/edit-attachment/price-comparison/:id/:transid/:msr"
                  element={<EditAttachmentPriceComparisonPage />}
                />
                <Route
                  path="/procurment/transaction/form-material-and-services-request"
                  element={<InsertPurchaseRequisitionPage />}
                />
                <Route
                  path="/procurment/transaction/form-material-and-services-request/:id"
                  element={<InsertPurchaseRequisitionPage />}
                />
                <Route
                  path="/procurment/transaction/form-material-and-services-request/:id/:transid"
                  element={<InsertPurchaseRequisitionPage />}
                />
                <Route
                  path="/procurment/monitoring"
                  element={<MonitoringProcurmentPage />}
                />

                <Route
                  path="/procurment/report/Material-and-Services-Request"
                  element={<MonitoringPurchaseRequisiton />}
                />
                <Route
                  path="/procurment/laporan/purchase-order"
                  element={<ReportPurchaseOrder />}
                />
                <Route
                  path="/procurment/approval/purchase-order"
                  element={<ApprovalPurchaseOrderPage />}
                />
                <Route
                  path="/procurment/report/price-comparison"
                  element={<MonitoringPriceComparison />}
                />
                <Route
                  path="/procurment/report/purchase-order"
                  element={<MonitoringPurchaseOrder />}
                />

                <Route
                  path="/procurment/transaction/form-allocation"
                  element={<InsertAllocationPurchaseRequisitionPage />}
                />
                <Route
                  path="/procurment/transaction/form-allocation/:id/:transid"
                  element={<InsertAllocationPurchaseRequisitionPage />}
                />

                {/*<Route path="/procurment/report/price-comparison"*/}
                {/*       element={<MonitoringPurchaseComparasion/>}/>*/}
                <Route
                  path="/procurment/approval/price-comparison"
                  element={<ApprovalPurchaseComparationPage />}
                />

                <Route
                  path="/procurment/preview/price-comparison/:id/:transid/:msr"
                  element={<PreviewPurchaseComparationPage />}
                />

                <Route
                  path="/procurment/delete/price-comparison/:id/:transid/:msr"
                  element={<DeletePurchaseComparationPage />}
                />

                <Route
                  path="/procurment/report/purchase-requisition"
                  element={<PurchaseRequisitionPage />}
                />

                <Route
                  path="/procurment/transaksi/price-comparison"
                  element={<PriceComparisonPage />}
                />
                <Route
                  path="/procurment/transaksi/price-comparison/:id"
                  element={<PriceComparisonPage />}
                />
                <Route
                  path="/procurment/transaksi/form-price-comparison"
                  element={<InsertPriceComparisonPage />}
                />
                <Route
                  path="/procurment/transaksi/form-price-comparison/:id"
                  element={<InsertPriceComparisonPage />}
                />
                <Route
                  path="/procurment/transaksi/form-price-comparison/:id/:transid"
                  element={<InsertPriceComparisonPage />}
                />
                <Route
                  path="/procurment/transaksi/form-price-comparison/:id/:transid/:msr"
                  element={<InsertPriceComparisonPage />}
                />

                <Route
                  path="/procurment/transaksi/kirim-price-comparison"
                  element={<KirimPurchaseRequisitionPage />}
                />

                <Route
                  path="/procurment/transaksi/purchase-order"
                  element={<PurchaseOrderPage />}
                />
                <Route
                  path="/procurment/transaction/form-purchase-order"
                  element={<InsertPurchaseOrderPage />}
                />

                <Route
                  path="/procurment/blanco/po/:id"
                  element={<BlankoPO />}
                />
                <Route
                  path="/procurment/blanco/purchase-requisition/:bu/:id"
                  element={<BlankoPR />}
                />

                <Route
                  path="/gudang/blanco/:id"
                  element={<BlankoPenerimaan />}
                />
                {/*Gudang*/}
                <Route path="/gudang" element={<GudangIndexPage />} />
                <Route
                  path="/gudang/transaction/penerimaan-barang"
                  element={<PenerimaanBarangPage />}
                />
                <Route
                  path="/gudang/transaction/penerimaan-barang/:id"
                  element={<PenerimaanBarangPage />}
                />

                <Route
                  path="/gudang/approval/penerimaan-barang/"
                  element={<ApprovalPenerimaanBarangPage />}
                />
                <Route
                  path="/gudang/transaction/form-penerimaan-barang/:id"
                  element={<InsertPenerimaanBarangPage />}
                />
                <Route
                  path="/gudang/transaction/form-penerimaan-barang/:id/:transid"
                  element={<InsertPenerimaanBarangPage />}
                />
                <Route
                  path="/gudang/transaction/form-penerimaan-barang-add/:id/:transid"
                  element={<InsertPenerimaanBarangPageV1 />}
                />

                <Route
                  path="/gudang/transaction/edit-penerimaan-barang/:id/:transid"
                  element={<InsertPenerimaanBarangPage />}
                />

                <Route
                  path="/gudang/transaction/detail-penerimaan-barang/:id/:transid"
                  element={<ReadPenerimaanBarangPage />}
                />

                <Route
                  path="/gudang/transaction/form-penerimaan-barang/"
                  element={<InsertPenerimaanBarangPage />}
                />

                <Route
                  path="/gudang/transaction/pengeluaran-barang"
                  element={<PengeluaranBarang />}
                />
                <Route
                  path="/gudang/approval/pengeluaran-barang"
                  element={<ApprovalPengeluaranBarangPage />}
                />
                <Route
                  path="/gudang/transaction/form-pengeluaran-barang"
                  element={<InsertPengeluaranBarangPage />}
                />
                <Route
                  path="/gudang/transaction/form-pengeluaran-barang/:id/:transid"
                  element={<InsertPengeluaranBarangPage />}
                />
                <Route
                  path="/gudang/transaction/read-form-pengeluaran-barang/:id/:transid"
                  element={<ReadPengeluaranBarangPage />}
                />

                <Route
                  path="/gudang/transaction/return-barang"
                  element={<ReturnBarangPage />}
                />
                <Route
                  path="/gudang/transaction/form-return-barang"
                  element={<InsertReturnBarangPage />}
                />
                <Route
                  path="/gudang/approval/return-barang"
                  element={<ReturnPenerimaanBarangPage />}
                />

                <Route
                  path="/gudang/transaction/penerimaan-barang-user"
                  element={<PenerimaanBarangUserPage />}
                />
                <Route
                  path="/gudang/transaction/form-penerimaan-barang-user"
                  element={<InsertPenerimaanBarangUserPage />}
                />
                <Route
                  path="/gudang/approval/penerimaan-barang-user"
                  element={<ApprovalPenerimaanBarangUserPage />}
                />
                <Route path="/gudang/stock" element={<StockPage scope="all" />} />
                <Route path="/gudang/stock-bagian" element={<StockPage scope="bagian" />} />
                <Route
                  path="/gudang/stock/adjust"
                  element={<AdjustStockPage />}
                />

                {/* Kendaraan */}

                {/* HRD */}
                <Route path="/human-resource" element={<HumanResourcePage />} />
                <Route
                  path="/human-resource/transaksi/csr"
                  element={<MonCSR />}
                />
                <Route
                  path="/human-resource/transaksi/csr/add"
                  element={<InsertCSR />}
                />

                <Route
                  path="/human-resource/transaksi/monitoring"
                  element={<MonitoringPage />}
                />
                <Route
                  path="/human-resource/transaksi/karyawan"
                  element={<KaryawanPage />}
                />
                {/*<Route path="/tim" element={<TimPage/>}/>*/}
                <Route
                  path="/human-resource/transaksi/cuti"
                  element={<CutiPage />}
                />
                <Route
                  path="/human-resource/transaksi/entry-cuti"
                  element={<EntryCutiPage />}
                />
                <Route
                  path="/human-resource/transaksi/input-saldo-cuti"
                  element={<InputSaldoCutiPage />}
                />
                <Route
                  path="/human-resource/transaksi/izin"
                  element={<IzinPage />}
                />
                <Route
                  path="/human-resource/transaksi/perbaikan-absen"
                  element={<PerbaikanPage />}
                />
                <Route
                  path="/human-resource/transaksi/absensi"
                  element={<AbsensiPage />}
                />
                <Route
                  path="/human-resource/transaksi/jadwal-kerja"
                  element={<JadwalKerjaPage />}
                />
                <Route
                  path="/human-resource/transaksi/face-enrollment"
                  element={<FaceEnrollmentPage />}
                />
                <Route
                  path="/human-resource/transaksi/kiosk-device"
                  element={<KioskDevicePage />}
                />
                <Route
                  path="/human-resource/transaksi/sakit"
                  element={<SakitPage />}
                />
                <Route
                  path="/human-resource/transaksi/pelatihan"
                  element={<PelatihanPage />}
                />
                <Route
                  path="/human-resource/transaksi/tiket"
                  element={<TiketPage />}
                />
                <Route
                  path="/human-resource/transaksi/lembur"
                  element={<LemburPage />}
                />
                <Route
                  path="/human-resource/transaksi/claim-pengobatan"
                  element={<ClaimPengobatanPage />}
                />
                <Route
                  path="/human-resource/transaksi/phk"
                  element={<PhkPage />}
                />
                <Route
                  path="/human-resource/transaksi/resign"
                  element={<ResignPage />}
                />
                <Route
                  path="/human-resource/transaksi/promosi"
                  element={<PromosiPage />}
                />
                <Route
                  path="/human-resource/transaksi/kontrak-kerja"
                  element={<KontrakKerjaPage />}
                />
                <Route
                  path="/human-resource/transaksi/perjalanan-dinas"
                  element={<PerjalananDinasPage />}
                />
                <Route
                  path="/human-resource/transaksi/tarif-uang-saku"
                  element={<TarifUangSakuPage />}
                />
                <Route
                  path="/human-resource/transaksi/monitoring-lpd"
                  element={<LpdTrackerPage />}
                />
                <Route
                  path="/human-resource/report/sakit"
                  element={<SakitReport />}
                />
                <Route
                  path="/human-resource/report/izin"
                  element={<IzinReport />}
                />
                <Route
                  path="/human-resource/report/cuti"
                  element={<CutiReport />}
                />
                <Route
                  path="/human-resource/report/pelatihan"
                  element={<PelatihanReport />}
                />
                <Route
                  path="/human-resource/report/tiket"
                  element={<TiketReport />}
                />
                <Route
                  path="/human-resource/report/lembur"
                  element={<LemburReport />}
                />
                <Route
                  path="/human-resource/report/claim-pengobatan"
                  element={<ClaimReport />}
                />
                <Route
                  path="/human-resource/report/FileKaryawan"
                  element={<KaryawanFile />}
                />
                <Route
                  path="/human-resource/report/phk"
                  element={<PhkReport />}
                />
                <Route
                  path="/human-resource/report/resign"
                  element={<ResignReport />}
                />

                <Route
                  path="/human-resource/report/karyawan"
                  element={<KaryawanReport />}
                />

                <Route path="/logistic" element={<LogisticPage />} />
                <Route path="/finance" element={<FinancePage />} />
                <Route path="/accounting" element={<AccountingPage />} />
                <Route path="/fixed-assets" element={<FixedAssetPage />} />
                <Route path="/workshop" element={<WorkshopPage />} />
                {/* hse */}
                <Route path="/hse" element={<HsePage />} />
                <Route path="/general-affair" element={<GeneralAffairPage />} />
                <Route path="/general-affair/resep" element={<ResepPage />} />
                <Route path="/general-affair/prasmanan" element={<PrasmananPage />} />
                <Route path="/general-affair/prasmanan/barcode" element={<BarcodeKamarPage />} />
                {/* Equipment */}
                <Route path="/equipment" element={<EquipmentPage />} />
                <Route
                  path="/equipment/kendaraan"
                  element={<TransaksiKendaraanPage />}
                />
                <Route
                  path="/equipment/monitoring/kendaraan"
                  element={<MonitoringKendaraan />}
                />
                <Route
                  path="/equipment/report/kendaraan"
                  element={<ReportKendaraan />}
                />

                <Route
                  path="/equipment/kendaraan/form-kendaraan"
                  element={<InsertKendaraanPage />}
                />
                <Route
                  path="/equipment/kendaraan/form-kendaraan/:BisnisUnitID/:id"
                  element={<InsertKendaraanPage />}
                />
                <Route
                  path="/equipment/kendaraan/update-form-kendaraan/:BisnisUnitID/:id"
                  element={<UpdateKendaraanPage />}
                />
                <Route
                  path="/equipment/kendaraan/kendaraan/:id"
                  element={<ApprovalKendaraanPage />}
                />
                <Route
                  path="/equipment/kendaraan/preview/:id"
                  element={<PreviewKendaraanPage />}
                />

                {/* Finance */}
                <Route
                  path="/finance/report/invoice/"
                  element={<QuatationLaporan />}
                />
                <Route
                  path="/finance/report/invoice/cetak/"
                  element={<CetakInvoice />}
                />

                <Route
                  path="/finance/account-payable/"
                  element={<AccountPayable />}
                />
                <Route
                  path="/finance/pembayaran-ap"
                  element={<PembayaranAPPage />}
                />
                <Route
                  path="/finance/transaction/pembayaran-ap"
                  element={<InsertAccountPayable />}
                />
                <Route
                  path="/finance/transaction/pembayaran-ap/:transid"
                  element={<InsertAccountPayable />}
                />
                <Route
                  path="/finance/approval/pembayaran-ap/:transid"
                  element={<ApprovalAccountPayable />}
                />

                <Route path="/finance/kas-bank" element={<KasBankPage />} />
                <Route
                  path="/finance/pettycash/:BisnisUnit"
                  element={<PattyCashPage />}
                />
                <Route
                  path="/finance/penerimaan-kas/:BisnisUnit"
                  element={<PenerimaanCash />}
                />
                <Route
                  path="/finance/penerimaan-dana"
                  element={<PenerimaanDana />}
                />
                <Route
                  path="/finance/transaction/form-PettyCash/:BisnisUnit"
                  element={<InsertPettyCashPage />}
                />
                <Route
                  path="/finance/transaction/form-Penerimana-Kas/:BisnisUnit"
                  element={<InsertPenerimaanPage />}
                />
                <Route
                  path="/finance/transaction/insert-penerimaan-dana"
                  element={<InsertPenerimaanDana />}
                />

                <Route
                  path="/finance/transaction/form-kas-bank"
                  element={<InsertKasBankPage />}
                />
                <Route
                  path="/finance/transaction/form-kas-bank/:transid"
                  element={<InsertKasBankPage />}
                />
                <Route
                  path="/finance/transaction/form-kas-bank-edit/:transid"
                  element={<EditLockedKasBank />}
                />
                <Route
                  path="/finance/transaction/form-kas-bank/:transid/:approval"
                  element={<ApprovalCashBank />}
                />
                <Route
                  path="/finance/approval/form-kas-bank/:transid"
                  element={<ApprovalKasBankPage />}
                />
                <Route
                  path="/finance/approval/pattycash/:transid"
                  element={<ApprovalPattyCashPage />}
                />

                <Route
                  path="/finance/detail/form-kas-bank/:transid"
                  element={<DetailKasBank />}
                />

                <Route path="/accounting/jurnal" element={<JurnalPage />} />
                <Route
                  path="/accounting/Monitoring/jurnal"
                  element={<MonitoringJurnal />}
                />
                <Route path="/accounting/Closing" element={<Closing />} />

                <Route
                  path="/accounting/jurnal/blanco/:id"
                  element={<BlankoJurnal />}
                />
                <Route
                  path="/accounting/transaction/jurnal"
                  element={<InsertJurnalPage />}
                />
                {/* Splat ("*"), bukan ":transid": AccountingID format baru
                    ({5digit}/GM/{unit}/{MM}/{YYYY}) mengandung slash, sehingga
                    ":transid" — yang hanya cocok SATU segmen — tak pernah match dan
                    halaman jadi blank putih. Splat menampung ID berslash maupun
                    berdash. Halaman menormalisasi ke dash sebelum memanggil API. */}
                <Route
                  path="/accounting/transaction/jurnal/*"
                  element={<InsertJurnalPage />}
                />
                <Route
                  path="/accounting/approval/jurnal/*"
                  element={<ApprovalJurnalPage />}
                />
                <Route
                  path="/finance/report/Journal"
                  element={<ReportJurnalPage />}
                />
                <Route
                  path="/finance/report/buku-kas"
                  element={<ReportBukuKas />}
                />

                <Route
                  path="/finance/report/buku-kas/:BisnisUnit"
                  element={<ReportBukuKas />}
                />

                <Route
                  path="/accounting/report/neraca"
                  element={<ReportNeraca />}
                />
                <Route
                  path="/accounting/report/laba-rugi"
                  element={<ReportLabaRugi />}
                />
                <Route
                  path="/finance/report/buku-bank"
                  element={<ReportBukuBank />}
                />
                <Route
                  path="/finance/report/buku-bank/:BisnisUnit"
                  element={<ReportBukuBank />}
                />
                <Route
                  path="/finance/report/buku-besar"
                  element={<ReportBukuBesarPage />}
                />
                <Route
                  path="/finance/report/trial-balance"
                  element={<ReportTrialBalancePage />}
                />
                <Route
                  path="/finance/report/pembayaran-ap"
                  element={<MonitoringAP />}
                />
                <Route
                  path="/finance/report/pembayaran-non-po"
                  element={<MonitoringNonPO />}
                />
                <Route
                  path="/finance/report/Petty-Cash-HO"
                  element={<MonitoringPattyCashHO />}
                />
                <Route
                  path="/finance/report/Petty-CashSO"
                  element={<MonitoringPattyCashSO />}
                />
                <Route
                  path="/finance/report/penerimaan-HO"
                  element={<MonitoringPenerimaanHO />}
                />
                <Route
                  path="/finance/report/penerimaan-SO"
                  element={<MonitoringPenerimaanSO />}
                />
                <Route
                  path="/finance/report/penerimaan-dana"
                  element={<MonitoringPenerimaanDana />}
                />
                 <Route
                  path="/finance/report/monitoring-invoice-quatation"
                  element={<MonitoringInvoiceQuatation />}
                />

                <Route
                  path="/finance/report/blanco/pembayaran-non-po/:id"
                  element={<BlankoKasBank />}
                />
                <Route
                  path="/finance/report/blanco/pembayaran-ap/:id"
                  element={<BlankoPembayaranAP />}
                />
                <Route
                  path="/finance/report/pembayaran-ap/vocher/:id"
                  element={<Vocherpembayaran />}
                />
                <Route
                  path="/finance/detail/voucher-ap/:id"
                  element={<Vocherpembayaran />}
                />

                {/* Payroll */}
                <Route path="/payroll" element={<IndexPayroll />} />
                <Route path="/rekap-payroll" element={<RekapPayrollSO />} />
                <Route path="/payroll/:id" element={<IndexPayrollSO />} />
                <Route
                  path="/payroll/detail/:id"
                  element={<IndexPayrollDetail />}
                />
                <Route path="/payroll/slip/:date/:id" element={<SlipGaji />} />
                <Route
                  path="/payroll/report/:id"
                  element={<PayrollPageReport />}
                />

                <Route path="/memo" element={<IndexMemo />} />
                <Route path="/memo/report" element={<MemoReportPage />} />
                <Route path="/memo/report-all" element={<MemoReportAllPage />} />
                <Route
                  path="/memo/report/pdf/:id"
                  element={<ReportMemoPdf />}
                />
                <Route path="/memo/internalmemo" element={<InternalMemo />} />
                 <Route path="/memo/internalmemo-all" element={<InternalMemoAll />} />
                <Route
                  path="/memo/internalmemodetail/:for/:id"
                  element={<InternalMemoDetail />}
                />
              </Route>
            )}
            {/* Belum login & URL tak dikenal (mis. halaman client setelah logout)
                → ke login, jangan tampil layar kosong. */}
            {!user && <Route path="*" element={<Navigate to="/login" replace />} />}
          </>
        </Routes>
      </Router>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme="light"
      />
    </QueryClientProvider>
  );
}

export default App;
